<template>
<div>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="step==='paid'?$t('pay.payResult'):$t('pay.payWay')" center width="700px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <template v-if="step==='paid'">
        <div class="dialog-ctr w100p">
          <div class="mydialog df-l-c-fs">
            <img src="@/assets/icons/payok.png" class="pay-result-icon">
            <div class="f-m f-dark">{{$t('pay.paySuccess')}}</div>
            <div class="f-m mt40 pay-result-text">{{selectedPayText}}</div>
          </div>
        </div>
        <div class="dialog-btm w100p df-c-sa">
          <div class="themebtn" @click="close">{{$t('common.comfirm')}}</div>
        </div>
      </template>
      <template v-else>
        <div class="dialog-ctr w100p">
          <div class="mydialog df-w-c-fs">
            <div v-for="(x,i) in paytypes2_x" :key="i" class="item df-l-c-ct" @click="submitDialogPay(x)">
              <div class="imgbox df-c-ct">
                <img :src="x.icon|toimg" style="max-width:60px;max-height:60px;">
              </div>
              <div class="name" :class="sysEnv_x==='us'?'f-m':'f-xs'">{{x['name'+_lang]}}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </el-dialog>

  <el-dialog
    :visible.sync="isShowDialogCard" class="dialog-square"
    :title="$t('pay.payCardComfirm')" center width="700px"
    :close-on-click-modal="false" @close="closeDialogCard">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-ct h100p" style="height: 240px;">
          <div class="f-m f-dark text">{{$t('pay.payCardComfirmTip')}}</div>
        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="whitebtn" @click="closeDialogCard">{{$t('pay.payNot')}}</div>
        <div class="themebtn" @click="submitDialogCard">{{$t('pay.payComfirm')}}</div>
      </div>
    </div>
  </el-dialog>

  <DialogCash ref="DialogCash" @submitDialog="submitDialogCash" />

</div>
</template>

<script>
import DialogCash from '@/components/DialogCash'
// import {loadStripeTerminal} from '@stripe/terminal-js'
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'DialogPayway',
  components: { DialogCash },
  // props: ['showBindCustomerBtn'],
  data() {
    return {
      isShowDialog: false,
      step: '', // start/paid/scanning
      isCan: true,

      orderData: {},
      payPrice: 0,
      selectedPayWay: '',

      isShowDialogCard: false,

      cashResult: {
        received: 0,
        refund: 0,
      },

      // #region stripe
      // terminal: null,
      // discoveredReaders: [],
      // discoveredReader: {},
      // paymentIntentId: '',
      // #endregion
    }
  },
  computed: {
    ...mapState(['paytypes2_x']),
    selectedPayText() {
      if (this.selectedPayWay === 5) {
        return `${this.$t('calc.received')}：${this.toprice(this.cashResult.received, 2)} / ${this.$t('calc.change')}：${this.toprice(this.cashResult.refund, 2)}`
      } else if (this.selectedPayWay !== '') {
        const ITEM = this.paytypes2_x.find(x => x.value === this.selectedPayWay)
        return `${ITEM['name' + this._lang]}：${this.toprice(this.payPrice, 2)}`
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapMutations(['paytypes2_x_save']),
    async open(orderData) {
      // console.log(`%corderData:`, 'color: #00f;', orderData)
      this.orderData = orderData
      this.payPrice = orderData.userCost
      // 如果当前支付方式列表为空，可能是请求失败，这里重新请求一次
      if (this.paytypes2_x.length === 0) {
        await this.initPayType()
      }
      // 如果再次请求依然是空列表，需要提示用户
      if (this.paytypes2_x.length === 0) {
        this.$message.error(this.$t('pay.payTypeIsEmpty'))
        return
      }
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      // 如果已经支付完成了
      if (this.step === 'paid') {
        this.$emit('close')
        this.close()
        let timer = setTimeout(() => {
          this.step = 'start'
          clearTimeout(timer)
        }, 300)
      }
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.isCan = true
      this.orderData = {}
      this.payPrice = 0
    },
    // 银行卡支付对话框 关闭支付结果
    closeDialogCard() {
      this.isCan = true
      this.isShowDialogCard = false
    },
    closeAllDialog() {
      this.close()
      // this.isShowDialogCard = false
      this.closeDialogCard()
      this.$refs.DialogCash.close()
    },

    // 支付对话框 提交支付方式
    async submitDialogPay(item) {
      const { value } = item
      this.selectedPayWay = value
      if (this.isCan) {
        this.isCan = false
        switch (value) {
          case 5:
            // 现金
            this.$refs.DialogCash.open(this.payPrice)
            break;
          case 1: case 2:
            // 微信 支付宝
          case 11:
            // stripe刷卡机
          case 3: case 4: case 8: case 9: case 10: case 12: case 13:
            // Mastercard Visa 八達通 银联 Amex 信用卡 支票
          default:
            this.isShowDialogCard = true
            break
        }
        let timer = setTimeout(() => {
          this.isCan = true
          clearTimeout(timer)
        }, 1000)
      }
    },

    // #region 银行卡支付
    // 银行卡支付对话框 提交支付方式
    async submitDialogCard() {
      this.el_loading_x_save(true)

      await this.sendPay()

      this.el_loading_x_save(false)
    },
    // #endregion
    
    // 修改订单状态為已支付
    async sendPay() {
      const { id, payTypeList } = this.orderData
      let rD = {
        shopId: this.currentShopId,
        id,
        payType: this.selectedPayWay,
        printerId: this.printerId_x,
      }
      this.selectedPayWay === 5 && (rD.cashPayCallBack = {
        orderId: id,
        payCash: this.cashResult.received,
        returnCash: this.cashResult.refund,
      })

      const _R = await this.setData('order', rD)
      if (_R) {
        this.$refs.DialogCash.close()
        this.isShowDialogCard = false
        this.close()
        this.$parent.judgeCart && this.$parent.judgeCart()
        
        // 如果现金支付过，弹出钱箱
        if (payTypeList && payTypeList.includes(5)) {
          this.$tool.dsbridge_call(this.$tool.dsbridge_map.openCashDrawer, '')
        }

        this.$emit('submitDialog')
      }
    },
    // 現金支付
    async submitDialogCash(result) {
      this.el_loading_x_save(true)
      this.cashResult = result
      console.log(`%c点击了现金支付:`, 'color: #00f;', true)

      await this.sendPay()

      this.el_loading_x_save(false)
    },

    async initPayType() {
      this.$api.payway_change_search({shopId: this.currentShopId}).then(({ status, data, msg }) => {
        if (status === 0) {
          console.log(`%c支持修改支付方式的支付渠道:`, 'color: #f00;', data)
          const RESULT = data.map(x1 => ({
            name_zh: x1.name_zh,
            name_en: x1.name_en,
            value: x1.type,
            icon: x1.imgId,
          }))
          this.paytypes2_x_save(RESULT)
        } else { ElMessage.error(msg) }
      })
    },
  },
  created() {
    if (this.paytypes2_x.length === 0) {
      this.initPayType()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 40px;
  .item{width: 155px;height: 140px;}
  .imgbox{height: 80px;width: 80px;}
  .name{height: 40px;line-height: 40px;}

  .pay-result-icon{width:60px;height:60px;border-radius: 50%;padding: 60px;}
  .pay-result-text{color: #374978;}
  .text{text-align: center;line-height: 32px;word-break: normal;}
}
</style>